<script setup>
import { ref, onMounted } from 'vue'
import { LCDClient } from '@terra-money/terra.js';

const terra = new LCDClient({
  URL: 'https://lcd.terra.dev',
  chainID: 'columbus-5',
});

const pools = [
    {
        name: 'bLUNA-LUNA',
        tlp: 'terra1nuy34nwnsh53ygpc4xprlj263cztw7vc99leh2'
    },
    {
        name: 'LUNA-UST',
        tlp: 'terra17dkr9rnmtmu7x4azrpupukvur2crnptyfvsrvr'
    },
    {
        name: 'ANC-UST',
        tlp: 'terra1gecs98vcuktyfkrve9czrpgtg0m3aq586x6gzm'
    },
    {
        name: 'MIR-UST',
        tlp: 'terra17gjf2zehfvnyjtdgua9p9ygquk6gukxe7ucgwh'
    },   
    {
        name: 'MINE-UST',
        tlp: 'terra1rqkyau9hanxtn63mjrdfhpnkpddztv3qav0tq2'
    },  
    {
        name: 'VKR-UST',
        tlp: 'terra17fysmcl52xjrs8ldswhz7n6mt37r9cmpcguack'
    },  
    {
        name: 'STT-UST',
        tlp: 'terra1uwhf02zuaw7grj6gjs7pxt5vuwm79y87ct5p70'
    },  
    {
        name: 'PSI-UST',
        tlp: 'terra1q6r8hfdl203htfvpsmyh8x689lp2g0m7856fwd'
    },
    {
        name: 'APOLLO-UST',
        tlp: 'terra1n3gt4k3vth0uppk0urche6m3geu9eqcyujt88q'
    },
    {
        name: 'ORION-UST',
        tlp: 'terra14ffp0waxcck733a9jfd58d86h9rac2chf5xhev'
    },
]

const outputText = ref('')

onMounted(() => { main() })

var tvl = 0
var lunaPrice = 57.05 

function showText(s) {
    outputText.value = `${outputText.value}\n${s}`;
}

function f(n) {
    if (n >= 0.01)
        return parseFloat(n.toFixed(2)).toLocaleString()
    else
        return n.toFixed(5)
}

async function main() {
    await auctionStats()
    lunaPrice = await getLUNAPrice()
    console.log(`LUNA Price: ${lunaPrice}\n`)
    showText('Phase 1:')
    showText('---------------------------------------------------------')
    for (var i = 0; i < pools.length; i++) {
        showText(`${pools[i].name}... `)
        await process(pools[i].tlp)
        showText('')
    }
    console.log(`TVL: ${tvl}`)
}

async function auctionStats() {

        showText('Phase 2:')
        showText('---------------------------------------------------------')
        let auction = await terra.wasm.contractQuery(
            'terra1tvld5k6pus2yh7pcu7xuwyjedn7mjxfkkkjjap',
            { "state": {} }
        )
        let astroDeposited = auction.total_astro_delegated / 1e6
        let ustDeposited = auction.total_ust_delegated / 1e6
        let price = ustDeposited / astroDeposited
        let bonus = 10_000_000 / 2 // Half the bonus to each side
        let sellPriceWithPremium = (ustDeposited + bonus * price) / astroDeposited
        let buyPriceWithDiscount = ustDeposited / (astroDeposited + bonus)
        showText(`Total ASTRO deposited:                ${f(astroDeposited)}`)
        showText(`Total UST deposited:                  ${f(ustDeposited)}`)
        // showText(`Implied ratio:                        1 ASTRO = ${f(price)} UST`)
        // showText(`ASTRO bonus per 1,000 UST:            ${f(bonus / ustDeposited * 1000)} ASTRO`)
        // showText(`ASTRO bonus per 1,000 ASTRO:          ${f(bonus / astroDeposited * 1000)} ASTRO`)
        // showText(`Bonus multiplier:                     ${f(bonus / astroDeposited * 100)}%`)
        // showText(`Bonus multiplier (UST):               ${f(bonus * price / ustDeposited * 100)}%`) // Mathematically equiv to previous line
        // showText(`Bonus-adjusted ASTRO deposit ratio:   1 ASTRO = ${f(sellPriceWithPremium)} UST`)
        // showText(`Bonus-adjusted UST deposit ratio:     1 ASTRO = ${f(buyPriceWithDiscount)} UST`)
        showText('')
        showText('Hypothetical 1,000 UST deposit proceeds:')
        showText('---------------------------------------------------------')
        showText(`  * ASTRO-UST LP: 500 UST + ${f(500 / price)} ASTRO`)
        showText(`  * ASTRO Bonus: ${f(bonus / ustDeposited * 1000)} ASTRO`)
        showText('')
        showText('Hypothetical 1,000 ASTRO deposit proceeds:')
        showText('---------------------------------------------------------')
        showText(`  * ASTRO-UST LP: ${f(500 * price)} UST + 500 ASTRO`)
        showText(`  * ASTRO Bonus: ${f(bonus / astroDeposited * 1000)} ASTRO`)
        showText('')
        showText(`** Based on current deposits. `)
        showText(`** Deposits at end of phase 2 will determine actual amounts.`)
        showText('')
        showText('<a href="https://app.flipsidecrypto.com/dashboard/astroport-phase-2-VLLYBc" target="_blank">Charts →</a>')
        showText('\n\n')

}

async function process(tlp) {
    try {
        let stats = await getLockdropStats(tlp)
        let { price, totalShares } = await getTLPPrice(tlp)
        let pctMigrated = (stats.terraswap_amount_in_lockups / totalShares) * 100
        let astroPerDollar = (stats.incentives_share / stats.weighted_amount) / price 
        let lock2wk = astroPerDollar * (1 + 1 / 51 * 3)
        let lock52wk = astroPerDollar * 4
        let avgLock = (stats.weighted_amount / stats.terraswap_amount_in_lockups - 1) / 3 * 358 + 7
        tvl += (stats.terraswap_amount_in_lockups / 1e6) * price
        showText('---------------------------------------------------------')
        showText(`Locked LP Tokens:                     ${f(stats.terraswap_amount_in_lockups / 1e6)}`)
        showText(`Value per LP token:                   ${f(price)} UST`)
        showText(`Locked value:                         ${f((stats.terraswap_amount_in_lockups / 1e6) * price)} UST`)
        showText(`% of Terraswap LP locked:             ${f(pctMigrated)}%`)
        showText(`Average Lock Duration (days):         ${f(avgLock)}`)
        showText(`ASTRO allocated to this pool:         ${f(stats.incentives_share / 1e6)}`)
        showText(`ASTRO per $1,000 of LP (2wk lock):    ${f(lock2wk * 1000)}`)
        showText(`ASTRO per $1,000 of LP (52wk lock):   ${f(lock52wk * 1000)}`)
    } catch(e) {
        console.log(e)
    }
}

async function getLockdropStats(tlp) {
    let result = await terra.wasm.contractQuery(
        'terra1627ldjvxatt54ydd3ns6xaxtd68a2vtyu7kakj',
        {
            pool: {terraswap_lp_token: tlp}
        }
    )
    return result
}

async function getTLPPrice(tlp) {
    let pool = (await terra.wasm.contractQuery(
        tlp,
        { minter: {} }
    )).minter
    let poolInfo = await terra.wasm.contractQuery(
        pool,
        { pool: {} }
    )
    let ust = poolInfo.assets.filter((a) => a.info.native_token && a.info.native_token.denom == 'uusd')[0]
    let luna = poolInfo.assets.filter((a) => a.info.native_token && a.info.native_token.denom == 'uluna')[0]
    return { 
        price: (2 * (ust ? ust.amount : luna.amount * lunaPrice)) / poolInfo.total_share, 
        totalShares: poolInfo.total_share 
    } 
}

async function getLUNAPrice() {
    let pool = (await terra.wasm.contractQuery(
        pools.filter((p) => p.name == 'LUNA-UST')[0].tlp,
        { minter: {} }
    )).minter
    let poolInfo = await terra.wasm.contractQuery(
        pool,
        { pool: {} }
    )
    let ust = poolInfo.assets.filter((a) => a.info.native_token && a.info.native_token.denom == 'uusd')[0]
    let luna = poolInfo.assets.filter((a) => a.info.native_token && a.info.native_token.denom == 'uluna')[0]
    return ust.amount / luna.amount;
}

</script>

<template>
    <pre v-html="outputText"></pre>
</template>

<style scoped>

pre {
    margin-left: 20px;
    font-family: SourceCodePro
}
pre:deep(a) {
    color: #61afef;
    font-weight: bold;
}

</style>